module.exports = __webpack_public_path__ + "img/empty-cart-illustration.647acf31.svg";